import React, { useState } from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbCheckbox from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import MDefaultform from '../m_defaultForm'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'
import { closedAreaContent } from '../../../../../../utils/closedArea/content'

const FurtherTeamMate = ({ index, register, errors }) => {
  const t = useTranslations()

  return (
    <>
      <div className="m-Formblock-row-third">
        {['furtherteammatememberfirstname', 'furtherteammatememberlastname', 'furtherteammatememberbirthdate']
          .filter(Boolean)
          .map((formItem, i) => {
            const labelPath = closedAreaContent?.forms?.fanclub?.formfields?.group?.label

            return (
              <div className="m-Formblock-row-third-cell" key={`fanclub-${index + i}`}>
                <DfbInput
                  {...register(formItem + index, {
                    required: t('form.errorMessage.input'),
                  })}
                  error={errors[formItem + index]}
                  errorMessage={errors?.[formItem + index]?.message}
                  label={`${labelPath?.[formItem]}*`}
                  focused
                />
              </div>
            )
          })}
      </div>
      <div className="m-Formblock-spacer" />
    </>
  )
}

const MCupOfFansFanclubRegistration = ({ data }) => {
  const t = useTranslations()

  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const [furtherTeamMembers, setFurtherTeamMembers] = useState(1)

  return (
    <MDefaultform
      buttonLabel="Absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
      shouldPersist={data.form_definition[0].save_in_db}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbParagraph add_class="m-Formblock-text" text={data.text} />}
          {fields.teamname && (
            <div className="m-Formblock-input-half">
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.teamname.identifier, {
                    required: fields.teamname.required ? t('form.errorMessage.input') : false,
                  })}
                  error={errors[fields.teamname.identifier]}
                  errorMessage={errors?.[fields.teamname.identifier]?.message}
                  label={`${fields.teamname.label}${fields.teamname.required === 1 ? '*' : ''}`}
                  focused
                />
              </div>
              <div className="m-Formblock-input" />
            </div>
          )}
          <div className="m-Formblock-spacer" />
          <DfbHeadline
            headline={closedAreaContent.forms.fanclub.formfields.group.label.maindeclarant}
            headline_level="h4"
            add_class="m-Formblock-headline"
          />
          {(fields.maindeclarantfirstname || fields.maindeclarantlastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.maindeclarantfirstname, fields.maindeclarantlastname, fields.email].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      pattern:
                        formItem.identifier === fields.email?.identifier
                          ? {
                              value: emailRegex,
                              message: t('form.errorMessage.emailPattern'),
                            }
                          : undefined,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.maindeclarantphone || fields.maindeclarantmobile) && (
            <div className="m-Formblock-input-half">
              {[fields.maindeclarantphone, fields.maindeclarantmobile].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          <DfbHeadline
            headline={closedAreaContent.forms.fanclub.formfields.group.label.moreMember}
            headline_level="h4"
            add_class="m-Formblock-headline"
          />
          {[...Array(furtherTeamMembers)].map((_, i) => (
            <FurtherTeamMate index={i} required={i < 5} register={register} errors={errors} />
          ))}
          <DfbButton
            type="button"
            text="Teammitglied hinzufügen"
            disabled={furtherTeamMembers >= 10}
            onClick={() => setFurtherTeamMembers((prev) => prev + 1)}
          />
          <div className="m-Formblock-spacer" />
          {fields.dataprotection && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t('form.privacyText')}
                {...register(fields.dataprotection.identifier, {
                  required: true,
                })}
                error={errors[fields.dataprotection.identifier]}
              />
            </div>
          )}
          {fields.confirmation && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t('form.confirmationText')}
                {...register(fields.confirmation.identifier, {
                  required: true,
                })}
                error={errors[fields.confirmation.identifier]}
              />
            </div>
          )}
        </>
      )}
    </MDefaultform>
  )
}

export default MCupOfFansFanclubRegistration
